const isDev = process.env.NODE_ENV === "development"

export function useIsDev() {
  return isDev
}
